import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import Modal from 'react-modal';
import TextFieldGroup from '../../inputs/TextFieldGroup';
import { addNewVehicleColumn } from '../../actions/apiDepartmentUpdates';

const AddVehicleColumnButton = () => {
  const dispatch = useDispatch();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [input_name, setInputName] = useState('');
  const [name, setName] = useState('');
  const [errors, setErrors] = useState({ addVehicleColumnError: false, name: null });

  const input_types = useSelector((state) => state.settings_departments.input_types);
  const vehicle_columns = useSelector((state) => state.settings_departments.vehicle_columns);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setInputName('');
    setName('');
    setErrors({ addVehicleColumnError: false, name: null });
  };

  const input_types_sorted = () => {
    const newObj = Object.keys(input_types).map((key) => input_types[key]);
    return newObj.sort((a, b) => a.name.localeCompare(b.name));
  };

  const vehicle_columns_sorted = () => {
    const newObj = Object.keys(vehicle_columns).map((key) => vehicle_columns[key]);
    return newObj.sort((a, b) => a.name.localeCompare(b.name));
  };

  const selectColumns = () => {
    const columns = vehicle_columns_sorted();
    return columns.map((option) => ({
      value: option.id,
      label: option.name,
    }));
  };

  const inputColumns = () => {
    const input_types = input_types_sorted();
    return input_types.map((option) => ({
      value: option.name,
      label: `${option.name} (${option.description})`,
    }));
  };

  const addNewVehicleColumnHandler = () => {
    const errorType = 'add new vehicle column';
    const data = {
      name,
      input_name,
    };

    dispatch(addNewVehicleColumn(data, errorType)).then((resp) => {
      if (resp === 'success') {
        setErrors({ addVehicleColumnError: false, name: null });
        setName('');
        setInputName('');
        closeModal();
      } else {
        // Handle error response
        const errorMessage = resp?.error?.invalid_params?.name?.[0] || 'An error occurred while adding the column';
        setErrors({
          addVehicleColumnError: true,
          name: errorMessage,
        });
      }
    });
  };

  return (
    <span className="float-end">
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="d-flex justify-content-center pad-bottom-2 space-bottom-2"
        contentLabel="Add Department Column"
        ariaHideApp={false}
        overlayClassName="overlay"
      >
        <div className="bg-light col-md-8 mx-auto space-top-2 pad-top-1 pad-bottom-1 pad-left-2 pad-right-2 rounded shadow">
          <div className="modal-content border-0">
            <div className="container d-flex justify-content-between align-items-center">
              <h4 className="modal-title d-inline text-primary">Add Department Column</h4>
              <button className="btn btn-sm btn-danger" onClick={closeModal}>
                <i className="fa fa-times" /> Close
              </button>
            </div>
            <div className="modal-body">
              <div className="p-2">
                <TextFieldGroup
                  field="name"
                  label="Column Name"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                  type="text"
                  error={!!errors.name}
                  errorMessage={errors.name}
                />
                {errors.name && (
                  <div className="alert alert-danger mt-2 p-2 d-flex align-items-center" role="alert">
                    <i className="fa fa-exclamation-circle me-2" />
                    {errors.name}
                  </div>
                )}
              </div>
              <div className="p-2">
                <label className="form-label">Input Type</label>
                <Select
                  onChange={(e) => setInputName(e.value)}
                  value={inputColumns().filter(({ value }) => value === input_name)}
                  name="input_name"
                  options={inputColumns()}
                  className="text-capitalize"
                  isClearable={false}
                  isSearchable
                  placeholder="Choose Input Type"
                />
              </div>
            </div>
            <div className="modal-footer border-0">
              <button
                type="button"
                className="btn btn-success"
                onClick={addNewVehicleColumnHandler}
              >
                <i className="fa fa-plus me-2" /> Add Column
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <button className="btn btn-sm btn-primary float-end" onClick={openModal}>
        <i className="fa fa-plus me-2" /> Create New Column
      </button>
    </span>
  );
};

export default AddVehicleColumnButton;